import log, {type Logger} from "@atg-shared/log";

export type ApolloConfigOptions = {
    logger: Logger;
    devToolsEnabled: boolean;
};

export const createDefaultOptions = ({
    logger = log,
    devToolsEnabled = false,
}: Partial<ApolloConfigOptions> = {}): ApolloConfigOptions => ({
    logger,
    devToolsEnabled,
});
